<nav class="sidebar d-flex flex-column">
  <!-- Logo -->
  <div class="sidebar-logo">
    <img src="/static/images/idio-logo.png" alt="Idio" height="60">
  </div>

  <!-- Nav links -->
  <ul class="nav flex-column flex-grow-1 p-2">
    <li class="nav-item">
      <a class="nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <i class="bi bi-house-door me-2"></i>Home
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/townships" routerLinkActive="active">
        <i class="bi bi-people-fill me-2"></i>Townships
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLink="/users" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <i class="bi bi-hammer me-2"></i>Users
      </a>
    </li>
  </ul>

  <!-- User + logout -->
  <div class="sidebar-footer">
    <span class="sidebar-username">{{ userName || userEmail }}</span>
    <button class="btn btn-sm sidebar-logout ms-auto" (click)="logout()" title="Logout">
      <i class="bi bi-box-arrow-right"></i>
    </button>
  </div>
</nav>
